import { callApi } from "@/api/api-core";

export const newsletterSubscribe = function(email, name, ownerHandlesFailure) {
    const requestData = {
        platform: "Web",
        email,
        name
    };

    return callApi(
        "POST",
        "v2/customer/newsletter/subscribe",
        requestData,
        ownerHandlesFailure
    );
};
